import { SITE_NAME } from "@shared/const";
import { useEffect } from "react";
import { useLocation } from "wouter";

const SITE = SITE_NAME;

/**
 * Client-side <title> updates for SPA navigations. The initial title comes
 * from SSR (server/_core/vite.ts buildHeadTags); this keeps it in sync as the
 * user navigates without a full page load.
 */
const ROUTE_TITLES: Record<string, string> = {
  "/": `${SITE} | Septic Pumping, Installation & Repair in Charlotte, NC`,
  "/careers": `Careers | ${SITE}`,
  "/maintenance-plans": `EZ Maintenance Plans | ${SITE}`,
  "/commercial": `Commercial Septic Maintenance & Compliance | ${SITE}`,
  "/residential": `Residential Septic Service for Homeowners | ${SITE}`,
  "/blog": `Septic System Blog | ${SITE}`,
  "/guides": `Septic System Guides | ${SITE}`,
  "/about-us": `About Us | ${SITE}`,
  "/cart": `Cart | ${SITE}`,
  "/order-confirmation": `Order Confirmation | ${SITE}`,
  "/admin": `Admin Dashboard | ${SITE}`,
  "/services/septic-pumping": `Septic Tank Pumping | ${SITE}`,
  "/services/septic-installation": `Septic System Installation | ${SITE}`,
  "/services/septic-inspection": `Septic System Inspection | ${SITE}`,
  "/services/septic-repairs": `Septic System Repairs | ${SITE}`,
  "/services/septic-system-design": `Septic System Design | ${SITE}`,
  "/faq": `Frequently Asked Questions | ${SITE}`,
  "/privacy": `Privacy Policy | ${SITE}`,
  "/terms": `Terms & Conditions | ${SITE}`,
  "/sitemap": `Sitemap | ${SITE}`,
  "/schedule": `Schedule Your Service | ${SITE}`,
};

export default function Head() {
  const [location] = useLocation();

  useEffect(() => {
    const clean = location.replace(/\/+$/, "") || "/";
    const t = ROUTE_TITLES[clean];
    if (t) document.title = t;
  }, [location]);

  return null;
}
